<template>
  <v-footer class="ps-0 pe-0 footer" color="white" elevation="1" height="auto">
    <div class="flex-grow-1 footerStyle me-0">
      <div class="mb-2 me-4" align="right"><a href="https://www.okinawagas.co.jp/privacypolicy.jsp "
          target="_blank">プライバシーポリシー</a>&ensp;|&ensp;<a href="https://www.okinawagas.co.jp/mailform.jsp"
          target="_blank">お問い合わせ</a></div>
      <div class="mb-2 ms-4">【お問い合わせ窓口】</div>
      <div class="mb-2 ms-7">沖縄ガス株式会社 財務部料金課</div>
      <div class="mb-4  ms-7">
        電話番号：平日 098-863-7438、 土曜・日曜・祝祭日 098-863-7730<br>
        受付時間：平日 8:30 〜 17:30<br>
      </div>
      <v-divider></v-divider>
      <v-row class="ms-4 mt-1 mb-1">
        <v-col cols="5" md="1" class="pt-0">
          <v-img class="changeSize shrink mr-2" :src="require('../../../assets/logo_footer.png')" width="auto" />
        </v-col>
        <v-col cols="12" md="11" class="pt-0">
          〒900-8605 沖縄県那覇市西3-13-2
        </v-col>
      </v-row>
      <div align="center" style="background-color:#009DE6">
        <font color="white">Copyright (c) Okinawa Gas. All Rights Reserved.<br></font>
      </div>
    </div>
  </v-footer>
</template>
  
<script>
export default {
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  created() {
  }
}
</script>
<style scoped>
@media screen and (max-width:600px) {
  .footer {
    font-size: .8em;
  }
}
</style>
<style>
</style>